import React, { useState, useEffect } from 'react';
import AdminNav from './AdminNav';
import './AdminLayout.css';
import './AdminDashboard.css';

import { API, authHeadersOnly } from '../services/apiConfig';

function Reports() {
  const [stats, setStats] = useState({
    totalRevenue: 0,
    ordersToday: 0,
    ordersThisMonth: 0,
    topProducts: []
  });

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const ordersRes = await fetch(`${API}/api/orders`, { headers: authHeadersOnly() });
      const orders = await ordersRes.json();
      
      const now = new Date(); const todayStr = now.toISOString().slice(0, 10); const thisMonth = now.getUTCMonth(); const thisYear = now.getUTCFullYear();
      
      
      const ordersToday = orders.filter(o => o.createdAt && o.createdAt.slice(0, 10) === todayStr).length;
      const ordersThisMonth = orders.filter(o => new Date(o.createdAt).getMonth() === thisMonth).length;
      const totalRevenue = orders.reduce((sum, o) => sum + (o.totalAmount || 0), 0);
      
      setStats({
        totalRevenue,
        ordersToday,
        ordersThisMonth,
        topProducts: []
      });
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <>
      <AdminNav onLogout={handleLogout} />
      <div className="admin-page-wrapper">
        <div className="admin-page-container">
          
          <div className="admin-page-header">
            <h1 className="admin-page-title">Reports & Analytics</h1>
            <p className="admin-page-subtitle">Track performance metrics and business insights</p>
          </div>

          <div className="admin-stats-grid">
            <div className="admin-stat-card revenue">
              <div className="admin-stat-icon-wrapper">
                <i className="fas fa-rupee-sign admin-stat-icon"></i>
              </div>
              <div className="admin-stat-value">₹{stats.totalRevenue.toFixed(2)}</div>
              <div className="admin-stat-label">Total Revenue</div>
            </div>

            <div className="admin-stat-card users">
              <div className="admin-stat-icon-wrapper">
                <i className="fas fa-calendar-day admin-stat-icon"></i>
              </div>
              <div className="admin-stat-value">{stats.ordersToday}</div>
              <div className="admin-stat-label">Orders Today</div>
            </div>

            <div className="admin-stat-card products">
              <div className="admin-stat-icon-wrapper">
                <i className="fas fa-calendar-alt admin-stat-icon"></i>
              </div>
              <div className="admin-stat-value">{stats.ordersThisMonth}</div>
              <div className="admin-stat-label">Orders This Month</div>
            </div>
          </div>



        </div>
      </div>
    </>
  );
}

export default Reports;
